const DOMAIN_NAME = window?.env?.domain_name;

export const profileImageGenerator = (id = '') =>
	`https://${DOMAIN_NAME}/images/users/${id}/profile_image`;
